import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable, ReplaySubject, of, throwError } from 'rxjs';
import { catchError, map, switchMap, tap } from 'rxjs/operators';
import { RequestMetadata } from '../../common.interface';
import { Reduction } from './reduction.interface';
import { CompanyConfigurableService } from '../company-configurable/company-configurable.service';

@Injectable({ providedIn: 'root' })
export class ReductionService extends CompanyConfigurableService<Reduction> {

  baseUrl = environment.settings_url + '/reductions';

  private _reduction = new ReplaySubject<Reduction>(1);
  private _reductions = new ReplaySubject<Reduction[]>(1);
  private _metadata = new ReplaySubject<RequestMetadata>(1);

  // -------- streams ----------
  set reduction(value: Reduction) { this._reduction.next(value); }
  get reduction$() { return this._reduction.asObservable(); }

  set reductions(value: Reduction[]) { this._reductions.next(value); }
  get reductions$() { return this._reductions.asObservable(); }

  set metadata(value: RequestMetadata) { this._metadata.next(value); }
  get metadata$() { return this._metadata.asObservable(); }

  constructor(protected override _httpClient: HttpClient) {
    super(_httpClient);
  }

  // -------- CRUD ----------
  create(reduction: Reduction): Observable<Reduction> {
    return this._httpClient.post<Reduction>(`${this.baseUrl}`, reduction)
      .pipe(
        tap((reduction) => {
          this.reduction = reduction;
          return (reduction);
        }),
        switchMap((created) =>
          this.getAll().pipe(
            map(() => created)
          )
        ),
        catchError((err) => throwError(() => err))
      );
  }
  


  update(id: string, reduction: Reduction): Observable<Reduction> {
    return this._httpClient.put<Reduction>(`${this.baseUrl}/${id}`, reduction)
      .pipe(
        tap((res) => { this.reduction = res;
          return res; }),
        switchMap((updated) =>
          this.getAll().pipe(
            map(() => updated)
          )
        ),
        catchError((err) => throwError(() => err))
      );
  }

  get(id: string): Observable<Reduction> {
    return this._httpClient.get<Reduction>(`${this.baseUrl}/${id}`).pipe(
      tap((res) => this.reduction = res),
      catchError(() => of({} as Reduction))
    );
  }

  getAll(): Observable<Reduction[]> {
    return this._httpClient.get<Reduction[]>(`${this.baseUrl}`)
      .pipe(
        tap((response: Reduction[]) => {
          this.reductions = response?.map((coverage: Reduction) => {
            return coverage;
          });
          //this.metadata = response;
          return response;
        }),
        catchError(() => of([] as Reduction[]))
      );
  }

  delete(id: string): Observable<void> {
    return this._httpClient.delete<void>(`${this.baseUrl}/${id}`).pipe(
      catchError((err) => throwError(() => err))
    );
  }
}
